import { FC, ReactNode } from 'react';

import { ROOT_ELEMENT_ID, ROOT_ELEMENT_VARIANT } from '@lib/tools/shared/helpers/consts';

import * as S from '@components/web/src/atoms/RootElement/styles';

interface IProps {
  children: ReactNode;
  isKioskVariant?: boolean;
  isMocked?: boolean;
}

export const RootElement: FC<IProps> = ({ children, isKioskVariant, isMocked = false }) => {
  return (
    <>
      {!isKioskVariant && isMocked && <S.GlobalMockBackground />}
      <S.RootContainer
        $isMocked={isMocked}
        {...(isKioskVariant ? { 'data-variant': ROOT_ELEMENT_VARIANT.KIOSK } : {})}
        id={ROOT_ELEMENT_ID}
      >
        {children}
      </S.RootContainer>
    </>
  );
};
